// extracted by mini-css-extract-plugin
module.exports = {"betaTag":"FeatureListItem-BetaTag-module--beta-tag--2Gc6w","small":"FeatureListItem-BetaTag-module--small--3p4P-"};